import axios from "axios";

const baseUrl = process.env.REACT_APP_ORDERS_SERVICE_BASE_URL;
const token = localStorage.getItem("token");

export const getAllHelperPricing = async () => {
  let response;
  const params = {
    page: 1,
    limit: 100,
  };
  await axios
    .get(`${baseUrl}/api/v1/helper-pricing/get-all-prices`, {
      headers: { Authorization: `Bearer ${token}` },
      params: params,
    })
    .then((res) => {
      response = res.data.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};

export const getHelperPricingById = async (id: string) => {
  let response;

  await axios
    .get(`${baseUrl}/api/v1/helper-pricing/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      response = res.data.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};

export const updateHelperPricing = async (id: string, reqBody: any) => {
  let response;

  await axios
    .patch(`${baseUrl}/api/v1/helper-pricing/${id}`, reqBody, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      console.log("res: ", res);
      response = res.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};

export const createHelperPricing = async (reqBody: any) => {
  let response;

  await axios
    .post(`${baseUrl}/api/v1/helper-pricing/create-price`, reqBody, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      console.log("res: ", res);
      response = res.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
};

export const deleteHelperPricing = async (id: string) => {
  let response: any;

  await axios
    .delete(`${baseUrl}/api/v1/helper-pricing/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      console.log("delete helper pricing res: ", res);
      response = res.data;
    })
    .catch((e) => {
      console.log("Error:", e);
      response = {};
    });

  return response;
}; 